import {newRepoPath} from '@github-ui/paths'
import {RepoIcon} from '@primer/octicons-react'
import {Octicon} from '@primer/react'
import {Blankslate} from '@primer/react/drafts'

export interface UserInfo {
  directOrTeamMember: boolean
  admin: boolean
  canCreateRepository: boolean
}

interface Props {
  currentPage: number
  pageCount: number
  filtered?: boolean
  orgName?: string
  userInfo?: UserInfo
}

export function NoReposMessage({currentPage, filtered, orgName, pageCount, userInfo}: Props) {
  const {directOrTeamMember, admin, canCreateRepository} = userInfo || {}

  const [message, showRepoCreateButton] = (() => {
    if (filtered) {
      return ['No repositories matched your search', false]
    }

    if (currentPage > pageCount) {
      return ['This organization has no more repositories.', false]
    } else if (admin) {
      return ['This organization has no repositories.', canCreateRepository]
    } else if (directOrTeamMember) {
      return ["Your teams don't have access to any repositories.", canCreateRepository]
    } else {
      return ['This organization has no public repositories.', false]
    }
  })()

  return (
    <Blankslate border={true}>
      <Blankslate.Visual>
        <Octicon icon={RepoIcon} size={24} />
      </Blankslate.Visual>
      <Blankslate.Heading>{message}</Blankslate.Heading>
      {filtered && <Blankslate.Description>Try a different search query</Blankslate.Description>}
      {showRepoCreateButton && (
        <Blankslate.PrimaryAction href={newRepoPath({org: orgName || ''})}>New repository</Blankslate.PrimaryAction>
      )}
    </Blankslate>
  )
}

try{ NoReposMessage.displayName ||= 'NoReposMessage' } catch {}